import { render, staticRenderFns } from "./AdminIntegrationsView.vue?vue&type=template&id=a5a909e2"
import script from "./AdminIntegrationsView.vue?vue&type=script&lang=js"
export * from "./AdminIntegrationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports